import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { FlightEntryService } from "../services/flight-entry.service";
import { NavService } from "../services/nav/nav.service";

export const flightEntryGuard: CanActivateFn = async (route) => {
  const entry = inject(FlightEntryService);
  const router = inject(Router);
  const nav = inject(NavService);
  if (!(await entry.ensureReady())) return router.createUrlTree(["/duty-ofp-limits"]);
  if (route.routeConfig?.path === "edit-add-flightplan" && !nav.getParameters()?.registration) {
    return router.createUrlTree(["/add-menu"]);
  }
  return true;
};
